// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/campaigns_data_v2" endpoint
 * Used to fetch the data in CampaignDigest
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsDataV2 } from "./constants";
import type { EngagementCampaignsDataV2Params, EngagementCampaignsDataV2Result } from "./types";

export const getDataTableEngagementCampaignsDataV2 = reactQueryTableFetcherAdapter(
  engagementCampaignsDataV2,
  async (
    signal: AbortSignal,
    { appGroupId, query, limit = 20, start = 0, ...rest }: EngagementCampaignsDataV2Params
  ): Promise<EngagementCampaignsDataV2Result> => {
    // Strip out time values since apiDataTable passes them in separately but API expects them
    // in a nested object
    const { last_edited_start_date, last_edited_end_date, created_start_date, created_end_date, ...strippedQuery } =
      query;

    return fetch(
      "/engagement/campaigns_data_v2",
      "GET",
      {
        limit,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects({
          ...strippedQuery,
          ...formatLastEditedTime(last_edited_start_date, last_edited_end_date),
          ...formatCreatedAtTime(created_start_date, created_end_date),
        }),
        ...rest,
      },
      { signal }
    );
  }
);

// Override query to backend so date fields are nested in "edited"
const formatLastEditedTime = (lastEditedStartDate?: number, lastEditedEndDate?: number) => {
  if (lastEditedStartDate && lastEditedEndDate) {
    return {
      last_edited: {
        start_date: lastEditedStartDate,
        end_date: lastEditedEndDate,
      },
    };
  }
};

// Override query to backend so date fields are nested in "created_at"
const formatCreatedAtTime = (createdStartDate?: number, createdEndDate?: number) => {
  if (createdStartDate && createdEndDate) {
    return {
      created_at: {
        start_date: createdStartDate,
        end_date: createdEndDate,
      },
    };
  }
};
